var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0386 3.67922C10.0386 4.37871 9.8312 5.06248 9.44259 5.64408C9.05398 6.22568 8.50163 6.67898 7.85539 6.94666C7.20916 7.21434 6.49806 7.28438 5.81201 7.14791C5.12597 7.01145 4.4958 6.67462 4.00119 6.18001C3.50658 5.6854 3.16975 5.05523 3.03329 4.36919C2.89683 3.68315 2.96686 2.97205 3.23454 2.32581C3.50222 1.67957 3.95553 1.12722 4.53712 0.73861C5.11872 0.349999 5.8025 0.142578 6.50198 0.142578C6.96642 0.142578 7.42631 0.234056 7.85539 0.411789C8.28448 0.589522 8.67436 0.85003 9.00276 1.17844C9.33117 1.50685 9.59168 1.89672 9.76941 2.32581C9.94714 2.75489 10.0386 3.21478 10.0386 3.67922Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9964H13V11.3416C12.981 10.1853 12.51 9.08239 11.6879 8.26898C11.116 7.69149 10.4336 7.23511 9.68151 6.92704C8.9294 6.61898 8.12294 6.46555 7.31025 6.4759H5.68905C4.85824 6.46457 4.03404 6.62482 3.26801 6.94661C2.50197 7.26841 1.81059 7.74484 1.23712 8.34608C0.459503 9.15139 0.0172385 10.2223 0 11.3416",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96436 10.5437L5.69873 12.2781L8.83997 9.19556",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96436 10.5437L5.69873 12.2781L8.83997 9.19556",
    stroke: "#888888",
    strokeWidth: 1.83493,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivation);
export default __webpack_public_path__ + "static/media/activation.f01c9dd690e6d7c90cc8443fcbdb07c3.svg";
export { ForwardRef as ReactComponent };